import React, { forwardRef, useContext } from 'react';
import PropTypes from 'prop-types';

import TableComponentsContext from '../Table/TableComponentsContext';
import { TableRowRoot } from './TableRowStyles';
import { conditionalClassNames } from 'UtilityComponents/Util';

/**
 *
 * @param {Boolean} hover - To define whether hover state is true or false
 * @param {Boolean} selected - To define whether selected state is true or false
 * @param {Object} classes - {
 *  root - Root class applied to the TableRow irrespective of its state
 *  selectedClass - Class applied when selected state is true
 *  hoverClass - Class applied when hover state is true
 *  headClass - Class applied when row is head row
 *  footerClass - Class applied when row is footer row
 * }
 */

const TableRow = ({ hover, selected, forwardRef, classes = {}, children, ...other }) => {
	const tablelvl2 = useContext(TableComponentsContext);
	const head = tablelvl2 && tablelvl2.variant === 'head';
	const footer = tablelvl2 && tablelvl2.variant === 'footer';

	const { root, selected: selectedClass, hover: hoverClass, head: headClass, footer: footerClass } = classes;
	const className = conditionalClassNames({
		[root]: root,
		[selectedClass]: selectedClass && selected,
		[hoverClass]: hoverClass && hover,
		[headClass]: headClass && head,
		[footerClass]: footerClass && footer
	});

	return (
		<TableRowRoot
			head={head}
			footer={footer}
			ref={forwardRef}
			hover={hover}
			selected={selected}
			className={className}
			children={children}
			{...other}
		/>
	);
};

TableRow.propTypes = {
	classes: PropTypes.object,
	hover: PropTypes.bool,
	selected: PropTypes.bool
};

export default forwardRef((props, ref) => <TableRow {...props} forwardedRef={ref} />);
